import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { Trans } from 'react-i18next';
import axios from 'axios';
import moment from 'moment';
import { useLazyQuery } from "@apollo/client";

import { GET_VEHICLE_BOOKINGS } from '../../../../../../GraphQL/Queries/bookings';

import { GridContainer, GridItem } from '../../../../../Common/DesignSystem/Grid';
import { LoadingIcon } from '../../../../../Common/Loading_Icon';

import { VehicleDetailsTabs } from './Tabs';
import { VehicleInformationCard } from './VehicleInformationCard';
import { VehicleSettingsCard } from './VehicleSettingsCard';
import { VehicleRemindersCard } from './VehicleRemindersCard';
import { VehicleStatusCard } from './VehicleStatusCard';
// import InformationCard from '../../VehicleDetails/InformationCard/InformationCard';
// import NewVehicleStatusCard from '../../VehicleDetails/StatusCard/StatusCard';
import VehicleDetailsCard from '../../VehicleDetails';

export const VehicleDetails = ({ props,
	vehicle, loadingVehicle,
	match, history, closeModal, settings, userSession,
	editVehicle, overlayRef, toInputRef, windowWidth, vehicle_usage_types, rr_vehicle, vehicle_oem_details, vehicle_options, legacyApiVehicleData,
}) => {
	const [currentTab, setCurrentTab] = useState('Overview');
	const [reports, setReports] = useState([]);
	const [bookings, setBookings] = useState([]);
	const [latestReport, setLatestReport] = useState(null);
	const [reminders, setReminders] = useState(null);
	const [useNewUI, setUseNewUI] = useState(false)

	useEffect(() => {
		fetchReports();
		fetchBookings();
	}, []);

	useEffect(() => {
		setReminders(legacyApiVehicleData?.reminders);
	}, [legacyApiVehicleData]);

	useEffect(() => {
		const tabs = ['Overview', 'Bookings', 'Reminders', 'Specifications', 'Media', 'RideReports', 'Expenses'];
		const { tab } = match.params;

		if (tab && tabs.includes(tab)) {
			setCurrentTab(tab);
		}
	}, [match.params.tab]);

	const fetchReports = () => {
		axios.post('/ajax/vehicle/' + match.params.v_id + '/ride_reports', {
			'V_ID': match.params.v_id
		}).then(response => {
			const rideReports = response.data?.reports || [];

			if (!rideReports.length) return;

			const sortedReports = rideReports.sort((a, b) => !moment(a.report_date).diff(moment(b.report_date)));
			const [latestRideReport] = sortedReports;

			setReports(sortedReports);
			setLatestReport(latestRideReport);
		})
	}

	const [getVehicleBookings, { data, loading }] = useLazyQuery(GET_VEHICLE_BOOKINGS, {
		variables: {
			stakeholderAndVehicleCenterInputs: userSession?.user?.profile_access?.active_sh_access,
			vehicleId: +match.params.id,
		},
		errorPolicy: 'all'
	});

	const fetchBookings = () => {
		getVehicleBookings().then(({ data }) => {
			const { getVehicleBookings } = data;
			const { bookings } = getVehicleBookings;

			setBookings(bookings);
		});
	}

	const setTab = (tab) => {
		setCurrentTab(tab);

		const { v_id, id } = match.params;
		const [basePath] = (match.url).split(`/${v_id}`);
		const redirectTo = `${basePath}/${v_id}/${tab}/${id}`;

		history.push(redirectTo);
	}

	return (
		<div className="main_overlay" ref={overlayRef} onScroll={() => ReactTooltip.rebuild()}>
			{loadingVehicle || !vehicle ? (
				<LoadingIcon />
			) : (
				<>
					<div className="overlay_responsive_close">
						<span onClick={closeModal}><Trans>Close</Trans> <span className="ml-8" style={{ fontSize: "18px" }}>&times;</span></span>
					</div>
					<div style={{ backgroundColor: 'white', display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
						<div className="overlay_header_close" onClick={closeModal} >
							&times;
						</div>
					</div>
					<div className="overlay_header" >
						<div className="overlay_header_info_container">
							<div style={{ flexGrow: 1 }}>
								{useNewUI ?
									<GridContainer justifyContent='space-evenly' spacing={3} direction={windowWidth <= 768 ? "column" : "row"}>
										<GridItem xs={windowWidth <= 768 ? 12 : 8} className="overlay_header_grid_item">
											{/* <InformationCard placeholderImage={settings.images.vehicle_placeholder_square} editVehicle={editVehicle} {...props} /> */}
											<VehicleDetailsCard {...props} vehicle={vehicle} editVehicle={editVehicle} toInputRef={toInputRef} />
										</GridItem>
										<GridItem xs={windowWidth <= 768 ? 12 : 4} className="overlay_header_grid_item">
											{/* <NewVehicleStatusCard {...props}
												vehicle={vehicle}
												setTab={setTab}
												latestReport={latestReport}
												vehicle_usage_types={vehicle_usage_types}
												rr_vehicle={rr_vehicle}
												legacyApiVehicleData={legacyApiVehicleData}
												editVehicle={editVehicle}
											/> */}
										</GridItem>
									</GridContainer> : <GridContainer justifyContent='space-evenly' spacing={3} direction={windowWidth <= 768 ? "column" : "row"}>
										<GridItem xs={windowWidth <= 768 ? 12 : 6} className="overlay_header_grid_item">
											<VehicleInformationCard {...props}
												vehicle={vehicle}
												placeholderImage={settings.images.vehicle_placeholder_square}
												editVehicle={editVehicle}
												toInputRef={toInputRef}
											/>
											<VehicleSettingsCard {...props} vehicle={vehicle} editVehicle={editVehicle} toInputRef={toInputRef} />
										</GridItem>
										<GridItem xs={windowWidth <= 768 ? 12 : 3} className="overlay_header_grid_item">
											<VehicleRemindersCard {...props} reminders={reminders} vehicle={vehicle} />
										</GridItem>
										<GridItem xs={windowWidth <= 768 ? 12 : 3} className="overlay_header_grid_item">
											<VehicleStatusCard {...props}
												vehicle={vehicle}
												setTab={setTab}
												latestReport={latestReport}
												vehicle_usage_types={vehicle_usage_types}
												rr_vehicle={rr_vehicle}
												legacyApiVehicleData={legacyApiVehicleData}
											/>
										</GridItem>
									</GridContainer>}
							</div>
						</div>
					</div>

					<VehicleDetailsTabs
						currentTab={currentTab}
						vehicle={vehicle}
						editVehicle={editVehicle}
						props={props}
						setTab={setTab}
						reports={reports}
						bookings={bookings}

						placeholderImage={settings.images.vehicle_placeholder_square}
						vehicle_oem_details={vehicle_oem_details}
						vehicle_options={vehicle_options}
						legacyApiVehicleData={legacyApiVehicleData}
					/>
				</>
			)}
		</div>
	)
}